<div class="admin-project-list-page">
  <app-projects-with-filters
    [displayType]="'admin'"
    [showGoToProjects]="false"
    [initialPageSize]="20"
  ></app-projects-with-filters>
</div>
